import React, { useEffect } from 'react';
import styles from './Login.module.scss';
import { Row, Col, Spin, Typography, Button, Card } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { useHistory } from 'react-router-dom';
import { showErrorNotification } from 'common';
import { getCookie, setCookie } from 'common/helpers';
import globalStyles from 'common/global.module.scss';
import { stPortalUrl } from 'authConfig';
import { LoginButtonSettings } from './Login.constants';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

const { Paragraph, Text } = Typography;
const enableAAD: string = process.env.REACT_APP_AZURE_ENABLE_AAD ?? '';

const Login: React.FC<{ location: Location }> = ({ location: { search } }) => {
  const login = useSelector((state: AppState) => state.login);

  const { inProgress } = useMsal();

  // extract query string parameters
  const urlParameters = new URLSearchParams(search);
  const returnTo = urlParameters.get('return_to');
  const history = useHistory();
  const errorMessage = getCookie('temperrormessage');
  const showStPortalLink = sessionStorage.getItem('showStPortalLinkInError');
  const loginButtonSetting = sessionStorage.getItem('loginButtonSetting');
  const loginErrorMessage = sessionStorage.getItem('loginErrorMessage');

  const clientLogin = () => {
    history.push('/public/signin');
  };

  const employeeLogin = () => {
    history.push('/public/employee-signin');
  };

  useEffect(() => {
    // if we got an error message, reset the cookie and show the error
    if (errorMessage && errorMessage !== 'undefined') {
      setCookie('temperrormessage', '');
      showErrorNotification(`Authenticating`, errorMessage);
    }
  }, [errorMessage]);

  if (showStPortalLink == 'true') {
    sessionStorage.removeItem('showStPortalLinkInError');
  }

  if (loginButtonSetting && inProgress == InteractionStatus.None) {
    sessionStorage.removeItem('loginButtonSetting');
  }

  if (loginErrorMessage && inProgress == InteractionStatus.None) {
    sessionStorage.removeItem('loginErrorMessage');
  }

  return (
    <>
      <Row type="flex" justify="end" align="top" className={styles.top}>
        <Col xs={24} md={8} lg={4}>
          <Paragraph>
            If you do not have a User Name or Password please contact a Customer
            Service Representative at &nbsp;
            <Text strong>516.663.0600</Text>
          </Paragraph>
        </Col>
      </Row>

      <Row type="flex" justify="center" align="middle">
        <Col xs={23} md={18} lg={12}>
          {showStPortalLink == 'true' && stPortalUrl && (
            <Paragraph className={styles.errorMessage}>
              <strong>
                Congratulations! Your account is ready for migration. Please
                complete your account migration by logging into your SearchTrax
                Portal account using this{' '}
                <a href={stPortalUrl} target="_blank" rel="noopener noreferrer">
                  link
                </a>
                .
              </strong>
            </Paragraph>
          )}
          {!showStPortalLink && loginErrorMessage && (
            <Paragraph className={styles.errorMessage}>
              <strong>{loginErrorMessage}</strong>
            </Paragraph>
          )}
          <Spin spinning={login.loading} size="large" tip="Authenticating...">
            <Row type="flex" justify="center" align="middle">
              <Col xs={24} md={20} lg={18}>
                {enableAAD === 'true' && (
                  <Card size="small">
                    <h2 className={globalStyles.textCenter}>
                      <br />
                      <strong>DataTraceID Sign In</strong>
                    </h2>
                    <br />
                    <Row type="flex" justify="space-around">
                      <Button
                        className={styles.loginButton}
                        type="primary"
                        onClick={() => clientLogin()}
                        disabled={
                          loginButtonSetting ===
                            LoginButtonSettings.EnableEmployeeLoginOnly ||
                          loginButtonSetting ===
                            LoginButtonSettings.EnableDbLoginOnly
                        }
                      >
                        CUSTOMER SIGN IN
                      </Button>
                      <Button
                        className={styles.loginButton}
                        type="primary"
                        onClick={() => employeeLogin()}
                        disabled={
                          loginButtonSetting ===
                            LoginButtonSettings.EnableCustomerLoginOnly ||
                          loginButtonSetting ===
                            LoginButtonSettings.EnableDbLoginOnly
                        }
                      >
                        EMPLOYEE SIGN IN
                      </Button>
                    </Row>
                    <br />
                  </Card>
                )}
              </Col>
            </Row>            
          </Spin>
          <Paragraph style={{textAlign: "center"}}>          
          <a href="https://www.firstam.com/privacy-policy/#type-of-information"  target="_blank">PRIVACY NOTICE:Learn more about why we collect this information and how we use it</a>
          </Paragraph>
        </Col>
      </Row>
    </>
  );
};

export default Login;
